"use strict";

define('app/template/list/template.detail.view',['vertebrae'], function (Vertebrae) {
  var TemplateDetailView = Vertebrae.View.extend({
    templates: {
      'template.detail': 'renderInitFragment'
    },
    render: function render() {
      var data = this.getDelegate().getTemplateDetails();
      this.$el.html(this.renderInitFragment(data));
    }
  });
  return TemplateDetailView;
});

